import React, {useState} from 'react';
import './services.css';
import staffingImage from '../Images/service-staffing.png';
import permanentImage from '../Images/service-permanent.png';
import contractImage from '../Images/service-contract.png';
import executiveImage from '../Images/service-executive.png';
import rpoImage from '../Images/service-rpo.png';
import globalImage from '../Images/service-global.png';

const services = [
  {title:'IT Staffing Solutions',desc:'Contract, contract-to-hire, and permanent placement for mission-critical roles.',details:'We identify, screen, and place skilled technology professionals who can contribute quickly to your roadmap. Our process covers engineering, QA, cloud, data, and project delivery roles, with careful attention to technical fit and team culture.',image:staffingImage},
  {title:'Permanent Hiring',desc:'Find professionals who align to your technical requirements, business goals, and culture.',details:'From role definition through offer acceptance, we build a focused search around the people most likely to stay and grow with your organization. Every shortlist is shaped by your goals, working style, and long-term capability needs.',image:permanentImage},
  {title:'Contract Staffing',desc:'Scale fast with flexible talent for short-term and long-term initiatives.',details:'Add experienced specialists when demand changes without slowing delivery. We manage sourcing, screening, and workforce coordination so your team can respond to launches, migrations, peak workloads, and urgent skill gaps with confidence.',image:contractImage},
  {title:'Executive Search',desc:'Recruit technology leaders and senior executives who drive innovation and growth.',details:'We run discreet, research-led searches for leaders who combine strategic judgment with the ability to execute. Our approach evaluates leadership style, business impact, and the context required to guide teams through meaningful change.',image:executiveImage},
  {title:'Recruitment Process Outsourcing (RPO)',desc:'Augment hiring capacity with scalable, managed recruitment support.',details:'Extend your internal hiring team with a flexible recruiting partner. We can support a single hiring program or the full recruitment lifecycle, bringing structured workflows, reporting, sourcing capacity, and a consistent candidate experience.',image:rpoImage},
  {title:'Global Talent Solutions',desc:'Build distributed and remote teams across regions with proven sourcing strategies.',details:'Reach specialized talent across markets while keeping communication and quality consistent. We help shape location strategy, source across regions, and build distributed teams that work well across time zones and cultures.',image:globalImage},
];

export default function Services(){
  const [expandedService, setExpandedService] = useState(null);

  return (
    <section id="services" className="zm-services">
      <div className="zm-container zm-services-inner">
        <div className="services-heading">
          <div>
            <span className="eyebrow">What We Do</span>
            <h2>Premium talent solutions for modern technology teams</h2>
          </div>
          <p className="services-intro">We deliver hiring solutions designed for modern technology organizations, combining speed, quality, and long-term talent partnerships.</p>
        </div>
        <div className="cards">
          {services.map((service) => (
            <div className="card" key={service.title}>
              <div className="card-image-wrap">
                <img className="card-image" src={service.image} alt={`${service.title} illustration`} />
              </div>
              <h3>{service.title}</h3>
              <p>{service.desc}</p>
              {expandedService === service.title && (
                <p className="card-details">{service.details}</p>
              )}
              <button
                type="button"
                className="more"
                aria-expanded={expandedService === service.title}
                onClick={() => setExpandedService(current => current === service.title ? null : service.title)}
              >
                {expandedService === service.title ? 'Show less ↑' : 'Learn more →'}
              </button>
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}
